import { TicketingFormCategory } from "@simplyk/common";

import { TicketingFrontendPageOutput } from "../../../types/trpc";

import { useTicketingTranslationField } from "@/hooks/useDonationTranslation";
import { useTranslate } from "@/hooks/useTranslate";

export const useTicketingHeadMetaContent = ({
  ticketing,
  startDate,
}: {
  ticketing: TicketingFrontendPageOutput;
  startDate: string | undefined;
}): {
  metaTitle: string;
  metaDescription: string;
} => {
  const { t } = useTranslate();

  const { ticketingField } = useTicketingTranslationField(ticketing as TicketingFrontendPageOutput);

  const title = ticketingField?.title;

  switch (ticketing.formCategory) {
    case TicketingFormCategory.Event:
    case TicketingFormCategory.Custom:
      return {
        metaTitle: `${t("common", "header.event.title1", { formTitle: title })}${ticketing?.address ? t("common", "header.event.address", { address: ticketing.address }) : ""}${t("common", "header.event.title2", { orgName: ticketing.organization?.name })}`,
        metaDescription: `${t("common", "header.event.description1", { formTitle: title, orgName: ticketing.organization?.name })}${startDate ? t("common", "header.event.startDate", { startDate }) : ""}${ticketing?.address ? t("common", "header.event.address", { address: ticketing.address }) : ""}${t("common", "header.event.description2", { orgName: ticketing.organization?.name })}`,
      };
    case TicketingFormCategory.MembershipV2:
      return {
        metaTitle: t("common", "header.membership.title", { formTitle: title, orgName: ticketing.organization?.name }),
        metaDescription: t("common", "header.membership.description", {
          formTitle: title,
          orgName: ticketing.organization?.name,
        }),
      };
    case TicketingFormCategory.Lottery:
      return {
        metaTitle: t("common", "header.lottery.title", { formTitle: title, orgName: ticketing.organization?.name }),
        metaDescription: t("common", "header.lottery.description", { orgName: ticketing.organization?.name }),
      };
    case TicketingFormCategory.Auction:
      return {
        metaTitle: t("common", "header.auction.title", { orgName: ticketing.organization?.name }),
        metaDescription: t("common", "header.auction.description", { orgName: ticketing.organization?.name }),
      };
    case TicketingFormCategory.Shop:
      return {
        metaTitle: t("common", "header.shop.title", { orgName: ticketing.organization?.name }),
        metaDescription: t("common", "header.shop.description", { orgName: ticketing.organization?.name }),
      };
  }
};
